import React, { useEffect, useState } from "react";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Loader from "../components/Loader/Loader";
import HeroBg from "../components/HeroBg/HeroBg";
import Meta from "../components/Meta";

function About() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const renderSection = ({ imgSrc, description, reverse = false }) => (
    <section
      className="about_section layout_padding-bottom"
      style={{ paddingTop: "0" }}
    >
      <div className="container">
        <div className="row align-items-center">
          {reverse ? (
            <>
              <div className="col-md-6">
                <div className="detail-box">
                  <p className="about-description">{description}</p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="img-box">
                  <img
                    src={imgSrc}
                    alt="About Vitri Enterprises"
                    className="about-image"
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="col-md-6">
                <div className="img-box">
                  <img
                    src={imgSrc}
                    alt="About Vitri Enterprises"
                    className="about-image"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="detail-box">
                  <p className="about-description">{description}</p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );

  const renderPartners = () => (
    <section className="partners-section">
      <div style={{ fontWeight: "bold" }}>
        <div className="partners-list">
          <div className="partner">
            <img
              src="https://res.cloudinary.com/ddffnw81j/image/upload/v1737007388/client-m_ljzydj.jpg"
              alt="Partner 1"
              className="partner-image"
            />
            <div className="partner-info">
              <h4>Dharmesh Bhuva</h4>
              <p>
                Dharmesh Bhuva is the owner of Vitri Enterprises, a trusted
                provider of security solutions including CCTV camera
                installation, video door phones, EPABX systems, and more. With a
                commitment to quality and reliability, Vitri Enterprises ensures
                the safety and satisfaction of both residential and commercial
                clients.
              </p>
            </div>
          </div>
          {/* <div className="partner">
            <img
              src="https://res.cloudinary.com/ddffnw81j/image/upload/v1737007388/client-m_ljzydj.jpg"
              alt="Partner 2"
              className="partner-image"
            />
            <div className="partner-info">
              <h4>Jignesh Bhuva</h4>
              <p>Partner description or introduction goes here.</p>
            </div>
          </div> */}
          {/* <div className="partner">
            <img
              src="https://res.cloudinary.com/ddffnw81j/image/upload/v1737007388/client-m_ljzydj.jpg"
              alt="Partner 1"
              className="partner-image"
            />
            <div className="partner-info">
              <h4>Partner Name</h4>
              <p>Partner description or introduction goes here.</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );

  return (
    <div>
      <Meta
        title="VITRI ENTERPRISES"
        description="Learn more about VITRI ENTERPRISES – a trusted name in Gujarat offering reliable CCTV, access control, EPABX, and networking solutions for residential, commercial, and industrial clients."
        keywords="About VITRI ENTERPRISES, CCTV Gujarat, EPABX provider, access control company, security systems company"
        canonical="https://vitrienterprises.in/about"
      />

      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="sticky-header">
            <Header />
          </div>
          <HeroBg title={"About Us"} />

          {/* About Content */}
          <section className="about_section layout_padding-bottom">
            <div className="square-box">
              <img
                src="https://res.cloudinary.com/ddffnw81j/image/upload/v1737007384/square_fkb3km.png"
                alt=""
                className="background-pattern"
              />
            </div>
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="img-box">
                    <img
                      src="images/home-1.jpg"
                      alt="About Vitri Enterprises"
                      className="about-image"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="detail-box">
                    <div className="heading_container">
                      <h2 className="section-title">About Vitri Enterprises</h2>
                    </div>
                    <p className="about-description">
                      Vitri Enterprises is a trusted distributor and wholesaler
                      of advanced security systems and office automation
                      products. Established in 2011, we offer innovative
                      solutions, including CCTV cameras, EPABX systems, fire
                      alarms, Home Automation, and video door phones, all designed to enhance the
                      security and efficiency of your business and home. Our
                      dedication to quality and customer satisfaction has
                      positioned us as an industry leader. We work closely with
                      renowned manufacturers to ensure we provide only the best
                      products to our clients.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {renderSection({
            imgSrc: "images/home-2.jpg",
            description:
              "At Vitri Enterprises, our mission is to provide state-of-the-art security and office automation solutions. Our innovative products ensure the safety and convenience of our clients, transforming their spaces into secure and efficient environments. We strive to exceed expectations with every project we undertake. Our partnerships with leading manufacturers allow us to deliver the highest quality products that align with the latest advancements in security technology. We are committed to staying ahead of industry trends and continuously improving our offerings to meet the evolving needs of our customers.",
            reverse: true,
          })}
          <section
            id="features-services"
            className="features-services-area about-p p-relative"
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-4 col-md-12">
                  <div className="features-box mb-30">
                    <div className="features-icon">
                      <img
                        decoding="async"
                        alt="Quality work icon"
                        src="https://nilkanthinfotech.com/wp-content/uploads/2021/09/se-icon1.png"
                        className="lazyloaded"
                      />
                    </div>
                    <div className="number"></div>
                    <div className="features-content">
                      <h4>
                        <a href="">Quality work</a>
                      </h4>
                      <p>
                        As a quality-based organization, we are committed to
                        achieving the highest standards of quality.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-12">
                  <div className="features-box mb-30">
                    <div className="features-icon">
                      <img
                        decoding="async"
                        alt="Timely delivery icon"
                        src="https://nilkanthinfotech.com/wp-content/uploads/2021/09/se-icon3-1.png"
                        className="lazyloaded"
                      />
                    </div>
                    <div className="number"></div>
                    <div className="features-content">
                      <h4>
                        <a href="">Timely delivery</a>
                      </h4>
                      <p>
                        Delivery is the ability of businesses to satisfy
                        customer demand and deliver services on time.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-12">
                  <div className="features-box mb-30">
                    <div className="features-icon">
                      <img
                        decoding="async"
                        alt="100% satisfaction icon"
                        src="https://nilkanthinfotech.com/wp-content/uploads/2021/09/se-icon2.png"
                        className="lazyloaded"
                      />
                    </div>
                    <div className="number"></div>
                    <div className="features-content">
                      <h4>
                        <a href="">100% satisfaction</a>
                      </h4>
                      <p>
                        Our staff is dedicated to fulfilling the objectives set
                        by our organization to achieve complete customer
                        satisfaction.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {renderPartners()}
          <Footer />
        </>
      )}
    </div>
  );
}

export default About;
